import React, { useCallback, useState } from 'react';
import propTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import ConfirmDialog from 'components/ConfirmDialog';
import HolidayCard from './components/HolidayCard';
import styles from './styles';
import { getOptions } from 'helpers/getOptions';
import $api from 'http/index';

const HolidaysList = ({
  classes,
  openSnackbar,
  holidays,
  toggleHolidayModal,
  getHolidays,
}) => {

  const [holidayId, setHolidayId] = useState(null);
  const openDeleteModal = useCallback((id) => setHolidayId(id), []);
  const closeDeleteModal = useCallback(() => setHolidayId(null), []);

  const deleteholiday = useCallback(async () => {
    try {
      await $api.delete(
        `${process.env.REACT_APP_BASE_URL}/holidays/${holidayId}`,
        getOptions()
      );
      getHolidays()
      setHolidayId(null);
    } catch (e) {
      openSnackbar('error', e.message)
    }
  }, [holidayId]);

  return holidays.length ? (
    <>
        <Grid container spacing={2} justifyContent="flex-start" className={classes.paddingVertical}>
          {holidays.map((holiday) => (
            <Grid key={holiday._id} item xs={12}>
              <HolidayCard
                holiday={holiday}
                toggleHolidayModal={toggleHolidayModal}
                openDeleteModal={openDeleteModal}
              />
            </Grid>
          ))}
        </Grid>
      {holidayId && (
        <ConfirmDialog
          isOpen={!!holidayId}
          onClose={closeDeleteModal}
          onSubmit={deleteholiday}
          text="Are you sure you want to delete this holiday?"
          disableEscape
          loadingOnSubmit
        />
      )}
    </>
  ) : (
    <Typography variant="h3" align="center" className={classes.noResultsBlock}>
      No Results
    </Typography>
  );
};

HolidaysList.propTypes = {
  openSnackbar: propTypes.func.isRequired,
  classes: propTypes.object.isRequired,
  holidays: propTypes.array.isRequired,
  getHolidays: propTypes.func.isRequired,
  hasMore: propTypes.bool.isRequired,
  toggleHolidayModal: propTypes.func.isRequired,
};

export default withStyles(styles)(HolidaysList);
